import React from 'react';
import { useNavigate } from 'react-router-dom';

const FONT = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
const GOLD = 'linear-gradient(180deg, #f6e7b4 0%, #d9b357 42%, #b98d2e 58%, #e8cc7a 100%)';

export default function ComingSoon({ title }) {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#000000', padding: '2rem 16px', boxSizing: 'border-box', fontFamily: FONT, display: 'flex', flexDirection: 'column' }}>
      <button
        onClick={() => navigate('/dashboard')}
        style={{ alignSelf: 'flex-start', background: 'none', border: 'none', color: '#D4AF37', cursor: 'pointer', padding: 0, fontSize: 14, marginBottom: '1.5rem', fontFamily: FONT }}
      >
        ← Back to dashboard
      </button>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ maxWidth: 720, width: '100%', textAlign: 'center', background: '#ffffff', borderRadius: 14, padding: '48px 28px', boxSizing: 'border-box' }}>
          <div style={{ fontSize: 13, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#8C6D1F', fontWeight: 700, marginBottom: 12 }}>{title}</div>
          <h1 style={{ margin: '0 0 12px', fontSize: 'clamp(40px, 9vw, 64px)', lineHeight: 1.05, fontWeight: 900, color: '#1a1a1a', textTransform: 'uppercase' }}>
            Coming <span style={{ background: GOLD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Soon!</span>
          </h1>
          <p style={{ margin: '0 0 24px', fontSize: 'clamp(17px, 3vw, 21px)', color: '#1a1a1a', lineHeight: 1.5, fontWeight: 600 }}>
            You are not going to believe what I'm building next for you. Just wait!
          </p>
          <div style={{ display: 'inline-block', padding: '10px 18px', background: GOLD, border: '1px solid #b8903a', borderRadius: 6, color: '#1a1a1a', fontWeight: 700, fontSize: 13, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            Stay tuned
          </div>
        </div>
      </div>
    </div>
  );
}
